var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar fixed-top navbar-dark bg-dark" }, [
    _c("a", { staticClass: "navbar-brand", attrs: { href: "/" } }, [
      _vm._v("Base2 Portal")
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "nav nav-pages mr-auto" }, [
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Work Metrics",
                to: { name: "Cards", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Cards"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/baseline-cards-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/baseline-cards-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Boards",
                to: { name: "Work", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Work"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/baseline-work-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/baseline-work-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Slack",
                to: { name: "Base2Bot", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Base2Bot"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/baseline-chat-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/baseline-chat-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Zendesk Summary",
                to: { name: "ZendeskSummary", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "ZendeskSummary"
                ? _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/zendesk-24px-active.svg") }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/zendesk-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Alerts",
                to: { name: "Alerts", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Alerts"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/baseline-alerts-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/baseline-alerts-24px.svg")
                    }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Incoming Calls",
                to: { name: "IncomingCalls", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "IncomingCalls"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/baseline-calls-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/baseline-calls-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("li", { staticClass: "nav-item dropdown" }, [
        _c(
          "div",
          {
            attrs: {
              href: "#",
              id: "navbarDropdown",
              role: "button",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false",
              title: "Shelvery"
            }
          },
          [
            _vm.$route.name.match(/ShelveryService|Shelvery/g)
              ? _c("img", {
                  staticClass: "links",
                  attrs: {
                    src: require("../assets/baseline-restore-24px-active.svg")
                  }
                })
              : _c("img", {
                  staticClass: "links",
                  attrs: { src: require("../assets/baseline-restore-24px.svg") }
                })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown-menu",
            attrs: { "aria-labelledby": "navbarDropdown" }
          },
          [
            _c(
              "router-link",
              {
                staticClass: "dropdown-item",
                attrs: {
                  to: { name: "Shelvery", params: { id: this.activeId } }
                }
              },
              [_vm._v("\n          summary\n        ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "dropdown-item",
                attrs: {
                  to: {
                    name: "ShelveryService",
                    params: { id: this.activeId, service: "ebs" }
                  }
                }
              },
              [_vm._v("\n          ebs\n        ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "dropdown-item",
                attrs: {
                  to: {
                    name: "ShelveryService",
                    params: { id: this.activeId, service: "rds" }
                  }
                }
              },
              [_vm._v("\n          rds\n        ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "dropdown-item",
                attrs: {
                  to: {
                    name: "ShelveryService",
                    params: { id: this.activeId, service: "ami" }
                  }
                }
              },
              [_vm._v("\n          ami\n        ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "dropdown-item",
                attrs: {
                  to: {
                    name: "ShelveryService",
                    params: { id: this.activeId, service: "redshift" }
                  }
                }
              },
              [_vm._v("\n          redshift\n        ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Tools",
                to: { name: "Tools", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Tools"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/baseline-tools-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/baseline-tools-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Backups",
                to: { name: "Backups", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name.match(/BackupService|Backups/g)
                ? _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/backups-24px-active.svg") }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/backups-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Monitoring",
                to: { name: "Monitoring", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Monitoring"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/monitor_heart_active_24dp.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/monitor_heart_white_24dp.svg")
                    }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "OpsTools",
                to: { name: "OpsTools", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "OpsTools"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/priority-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/priority-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Resources",
                to: {
                  name: "Resources",
                  params: { id: this.activeId, resource: "lambda" }
                }
              }
            },
            [
              _vm.$route.name === "Resources"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/resources-24px-active.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/resources-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Assets",
                to: { name: "Assets", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Assets"
                ? _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/assets-24px-active.svg") }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/assets-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Ciinabox Deployments",
                to: {
                  name: "CiinaboxDeployments",
                  params: { id: this.activeId }
                }
              }
            },
            [
              _vm.$route.name === "CiinaboxDeployments"
                ? _c("img", {
                    staticClass: "links",
                    attrs: {
                      src: require("../assets/deployments-active-24px.svg")
                    }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/deployments-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "Costs",
                to: { name: "Costs", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "Costs"
                ? _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/costs-24px-active.svg") }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/costs-24px.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "InsightsTester",
                to: { name: "InsightsTester", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "InsightsTester"
                ? _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/wand-stars-active.svg") }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/wand-stars.svg") }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "nav-item active" },
        [
          _c(
            "router-link",
            {
              attrs: {
                title: "AIPage",
                to: { name: "AIPage", params: { id: this.activeId } }
              }
            },
            [
              _vm.$route.name === "AIPage"
                ? _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/costs-24px-active.svg") }
                  })
                : _c("img", {
                    staticClass: "links",
                    attrs: { src: require("../assets/costs-24px.svg") }
                  })
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nav-item dropdown" }, [
      _c(
        "div",
        {
          attrs: {
            href: "#",
            id: "mgtDropdown",
            role: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            title: "Manage Contracts"
          }
        },
        [
          _vm.$route.name.match(/Management|NewContract/g)
            ? _c("img", {
                staticClass: "links",
                attrs: { src: require("../assets/management-24px-active.svg") }
              })
            : _c("img", {
                staticClass: "links",
                attrs: { src: require("../assets/management-24px.svg") }
              })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "dropdown-menu dropdown-menu-right dropdown-menu-lg-left",
          attrs: { "aria-labelledby": "mgtDropdown" }
        },
        [
          _c("h6", { staticClass: "dropdown-header" }, [_vm._v("Groups")]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "dropdown-item",
              attrs: { title: "Modify Group", to: { name: "GroupNew" } }
            },
            [_vm._v("\n        New Group\n      ")]
          ),
          _vm._v(" "),
          _vm.activeType == "group"
            ? _c(
                "router-link",
                {
                  staticClass: "dropdown-item",
                  attrs: {
                    title: "Modify Group",
                    to: { name: "GroupModify", params: { id: this.activeId } }
                  }
                },
                [_vm._v("\n        Modify Group\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeType == "group"
            ? _c(
                "router-link",
                {
                  staticClass: "dropdown-item",
                  attrs: {
                    title: "Delete Group",
                    to: { name: "GroupDelete", params: { id: this.activeId } }
                  }
                },
                [_vm._v("\n        Delete Group\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h6", { staticClass: "dropdown-header" }, [_vm._v("Contract")]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "dropdown-item",
              attrs: { title: "New Contract", to: { name: "ContractNew" } }
            },
            [_vm._v("\n        New Contract\n      ")]
          ),
          _vm._v(" "),
          _vm.activeType == "contract"
            ? _c(
                "router-link",
                {
                  staticClass: "dropdown-item",
                  attrs: {
                    title: "Modify Contract",
                    to: {
                      name: "ContractModify",
                      params: { id: this.activeId }
                    }
                  }
                },
                [_vm._v("\n        Modify Contract\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeType == "contract"
            ? _c(
                "router-link",
                {
                  staticClass: "dropdown-item",
                  attrs: {
                    title: "Delete Contract",
                    to: {
                      name: "ContractDelete",
                      params: { id: this.activeId }
                    }
                  }
                },
                [_vm._v("\n        Delete Contract\n      ")]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "modal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "Settings",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "toggle-group" }, [
                  _c("div", { staticClass: "namespace" }, [
                    _vm._v("global settings")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle" }, [
                    _c("div", { staticClass: "toggle-text" }, [_vm._v("dots")]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-toggle",
                        class: { active: _vm.settings.global.dots },
                        attrs: {
                          type: "button",
                          "aria-pressed": "true",
                          autocomplete: "off"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleSetting("global", "dots")
                          }
                        }
                      },
                      [_c("div", { staticClass: "handle" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle" }, [
                    _c("div", { staticClass: "toggle-text" }, [
                      _vm._v("week numbers")
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-toggle",
                        class: { active: _vm.settings.global.weekNumbers },
                        attrs: {
                          type: "button",
                          "aria-pressed": "true",
                          autocomplete: "off"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleSetting("global", "weekNumbers")
                          }
                        }
                      },
                      [_c("div", { staticClass: "handle" })]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$route.name === "Work" || _vm.$route.name === "Cards"
                    ? _c("div", { staticClass: "namespace" }, [
                        _vm._v("local settings")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.name === "Work"
                    ? _c("div", { staticClass: "toggle" }, [
                        _c("div", { staticClass: "toggle-text" }, [
                          _vm._v("show platform icons")
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-toggle",
                            class: { active: _vm.settings.work.icons },
                            attrs: {
                              type: "button",
                              "aria-pressed": "true",
                              autocomplete: "off"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleSetting("work", "icons")
                              }
                            }
                          },
                          [_c("div", { staticClass: "handle" })]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.name === "Work"
                    ? _c("div", { staticClass: "toggle" }, [
                        _c("div", { staticClass: "toggle-text" }, [
                          _vm._v("show zendesk tickets")
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-toggle",
                            class: { active: _vm.settings.work.zendesk },
                            attrs: {
                              type: "button",
                              "aria-pressed": "true",
                              autocomplete: "off"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleSetting("work", "zendesk")
                              }
                            }
                          },
                          [_c("div", { staticClass: "handle" })]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.name === "Work"
                    ? _c("div", { staticClass: "toggle" }, [
                        _c("div", { staticClass: "toggle-text" }, [
                          _vm._v("show trello cards")
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-toggle",
                            class: { active: _vm.settings.work.trello },
                            attrs: {
                              type: "button",
                              "aria-pressed": "true",
                              autocomplete: "off"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleSetting("work", "trello")
                              }
                            }
                          },
                          [_c("div", { staticClass: "handle" })]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.name === "Work"
                    ? _c("div", { staticClass: "toggle" }, [
                        _c("div", { staticClass: "toggle-text" }, [
                          _vm._v("show jira cards")
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-toggle btn-jira",
                            class: { active: _vm.settings.work.jira },
                            attrs: {
                              type: "button",
                              "aria-pressed": "true",
                              autocomplete: "off"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleSetting("work", "jira")
                              }
                            }
                          },
                          [_c("div", { staticClass: "handle" })]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.name === "Work"
                    ? _c("div", { staticClass: "toggle" }, [
                        _c("div", { staticClass: "toggle-text" }, [
                          _vm._v("show planned cards")
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-toggle btn-queue",
                            class: { active: _vm.settings.work.queue },
                            attrs: {
                              type: "button",
                              "aria-pressed": "true",
                              autocomplete: "off"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleSetting("work", "queue")
                              }
                            }
                          },
                          [_c("div", { staticClass: "handle" })]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.name === "Cards"
                    ? _c("div", { staticClass: "toggle" }, [
                        _c("div", { staticClass: "toggle-text" }, [
                          _vm._v("show labels")
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-toggle",
                            class: { active: _vm.settings.cards.labels },
                            attrs: {
                              type: "button",
                              "aria-pressed": "true",
                              autocomplete: "off"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleSetting("cards", "labels")
                              }
                            }
                          },
                          [_c("div", { staticClass: "handle" })]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { attrs: { title: "Logout" } }, [
      _c("img", {
        staticClass: "settings",
        attrs: {
          type: "button",
          width: "24px",
          src: require("../assets/logout-24dp.svg")
        },
        on: { click: _vm.logout }
      })
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "nav nav-pills" }, [
      _c("li", { staticClass: "nav-item dropdown" }, [
        _c(
          "button",
          {
            staticClass: "btn dropdown-toggle",
            attrs: {
              type: "button",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false"
            }
          },
          [_vm._v("\n        " + _vm._s(_vm.activeId) + "\n      ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown-menu dropdown-menu-right scrollable-menu" },
          [
            _c("form", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search"
                  }
                ],
                staticClass: "form-control search",
                attrs: {
                  type: "search",
                  id: "search",
                  placeholder: "filter",
                  autofocus: "autofocus"
                },
                domProps: { value: _vm.search },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "dropdown-header" }, [_vm._v("Groups")]),
            _vm._v(" "),
            _vm._l(_vm.filteredGroupList, function(group) {
              return _c("div", { key: group }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.updateActive(group, "group")
                      }
                    }
                  },
                  [_vm._v(_vm._s(group))]
                )
              ])
            }),
            _vm._v(" "),
            _c("h6", { staticClass: "dropdown-header" }, [_vm._v("Contracts")]),
            _vm._v(" "),
            _vm._l(_vm.filteredContractList, function(contract) {
              return _c("div", { key: contract }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.updateActive(contract, "contract")
                      }
                    }
                  },
                  [_vm._v(_vm._s(contract))]
                )
              ])
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { title: "Settings" } }, [
      _c("img", {
        staticClass: "settings",
        attrs: {
          width: "24px",
          src: require("../assets/settings-white-18dp.svg"),
          "data-toggle": "modal",
          "data-target": "#modal"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Settings")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4295d220", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4295d220","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = null
// module chunks = 